import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=67ee4178&"
import script from "./create-form.vue?vue&type=script&lang=ts&"
export * from "./create-form.vue?vue&type=script&lang=ts&"
import style0 from "./create-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports